import { Response as Client } from 'api/typegen/client/get';
import { datadogLogs } from '@datadog/browser-logs';
import {
  TINK_JOB_ID_COOKIE,
  TINK_RISK_INSIGHTS_REPORT_COOKIE,
  TINK_TRANSACTION_REPORT_COOKIE,
} from 'utils/constants';
import Cookie from 'js-cookie';

export const TINK_REPORT_PARAM = {
  JOB_ID: 'reports_generation_job_id',
  TRANSACTION: 'transaction_report_id',
  RISK_INSIGHTS: 'risk_insights_report_id',
} as const;

export type TinkReportIds = {
  reports_generation_job_id: string | null;
  transaction_report_id: string | null;
  risk_insights_report_id: string | null;
};

export function getTinkReportIdsFromSearch(
  search: string = window.location.search,
): TinkReportIds {
  const params = new URLSearchParams(search);
  return {
    reports_generation_job_id: params.get(TINK_REPORT_PARAM.JOB_ID),
    transaction_report_id: params.get(TINK_REPORT_PARAM.TRANSACTION),
    risk_insights_report_id: params.get(TINK_REPORT_PARAM.RISK_INSIGHTS),
  };
}

export function hasTinkReportIds(ids: TinkReportIds): boolean {
  return Boolean(
    ids.reports_generation_job_id ||
      ids.transaction_report_id ||
      ids.risk_insights_report_id,
  );
}

export function saveTinkReportsToCookies(ids: TinkReportIds) {
  if (ids.reports_generation_job_id) {
    Cookie.set(TINK_JOB_ID_COOKIE, ids.reports_generation_job_id, {
      expires: 1,
    });
  }
  if (ids.transaction_report_id) {
    Cookie.set(TINK_TRANSACTION_REPORT_COOKIE, ids.transaction_report_id, {
      expires: 1,
    });
  }
  if (ids.risk_insights_report_id) {
    Cookie.set(TINK_RISK_INSIGHTS_REPORT_COOKIE, ids.risk_insights_report_id, {
      expires: 1,
    });
  }
}

export function getTinkReportsFromCookies(): TinkReportIds {
  return {
    reports_generation_job_id: Cookie.get(TINK_JOB_ID_COOKIE) ?? null,
    transaction_report_id: Cookie.get(TINK_TRANSACTION_REPORT_COOKIE) ?? null,
    risk_insights_report_id:
      Cookie.get(TINK_RISK_INSIGHTS_REPORT_COOKIE) ?? null,
  };
}

export function clearTinkReportCookies() {
  Cookie.remove(TINK_JOB_ID_COOKIE);
  Cookie.remove(TINK_TRANSACTION_REPORT_COOKIE);
  Cookie.remove(TINK_RISK_INSIGHTS_REPORT_COOKIE);
}

export function buildTinkWaitingSearch(ids: TinkReportIds): string {
  const params = new URLSearchParams();
  if (ids.reports_generation_job_id) {
    params.set(TINK_REPORT_PARAM.JOB_ID, ids.reports_generation_job_id);
  }
  if (ids.transaction_report_id) {
    params.set(TINK_REPORT_PARAM.TRANSACTION, ids.transaction_report_id);
  }
  if (ids.risk_insights_report_id) {
    params.set(TINK_REPORT_PARAM.RISK_INSIGHTS, ids.risk_insights_report_id);
  }
  return params.toString();
}

export function datadogReportLogs(
  parentScreen: string,
  client?: Client | null | undefined,
) {
  datadogLogs.logger.info(
    `${parentScreen}: clientID: ${client?.id} - clientEmail: ${client?.email} - clientName: ${client?.fullName}`,
    getTinkReportIdsFromSearch(),
  );
}
